<div class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'">
    <div>
        <div class="row mt-2 mb-4">
            <div class="col-sm-4"></div>
            <div class="col-sm-4 text-center font-weight-bold">
                <div>জাতীয় রাজস্ব বোর্ড</div>
                <div>www.nbr.gov.bd</div>
            </div>
            <div class="col-sm-4 d-flex justify-content-end align-items-center">আইটি-১১গ (২০২৩)</div>
        </div>

        <div class="row">
            <div class="col-sm-4 bt bb bl br" style="font-size:14px">
                <div class="row bt bb bl br">
                    <div class="col-12 text-center py-1">দাপ্তরিক ব্যবহারের জন্য</div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">রিটার্ন রেজিস্টারের ক্রমিক নম্বর</div>
                    <div class="col-4 bl py-1 px-0 text-center">{{(returnData?.submissionInfo?.submissionStatus ? returnData?.submissionInfo?.referenceNo : '') | convertNumWithOtherCharsToBn}}</div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">রিটার্ন রেজিস্টারের ভল্যুম নম্বর</div>
                    <div class="col-4 bl py-1 px-0 text-center"></div>
                </div>
                <div class="row bt bb bl br">
                    <div class="col-8 br py-1">রিটার্ন দাখিলের তারিখ</div>
                    <div class="col-4 bl py-1 px-0 text-center">{{submissionDate | convertNumWithOtherCharsToBn}}</div>
                </div>
            </div>
            <div class="col-sm-4 m-auto text-center">
                <b>স্বাভাবিক ব্যক্তি করদাতার রিটার্ন</b>
                <br/><br/>
                <div>ধারাঃ {{ section?.bnValue }} [{{ section?.bnLabel }}]</div>
            </div>
            <div class="col-sm-4">

            </div>
        </div>

        <div class="row mt-4" style="border: 2px solid #666">
           <div class="col-sm-12">
                <div class="row my-4">
                    <div class="col-sm-2">১। করদাতার নাম:</div>
                    <div class="col-sm-10">{{userInfo?.assesName}}</div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-5">২। জাতীয় পরিচয় পত্র নম্বর/ পাসপোর্ট নম্বর (এনআইডি না থাকিলে):</div>
                    <div class="col-sm-7">
                        {{(userInfo?.smartId && userInfo?.smartId != '' ? userInfo?.smartId : userInfo?.nid) | convertNumWithOtherCharsToBn}}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-2">৩। টি আইএন:</div>
                    <div class="col-sm-10">
                        <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of userInfo?.tin?.split('')" class="input-default" disabled/>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-4">৪। (ক) সার্কেল:</div>
                            <div class="col-sm-8">{{userInfo?.circle}}</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-4">(খ) কর অঞ্চল:</div>
                            <div class="col-sm-8">{{userInfo?.zone}}</div>
                        </div>
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-5">
                        <div class="row">
                            <div class="col-sm-4">
                                ৫। করবর্ষ:
                            </div>
                            <div class="col-sm-8">
                                {{userInfo?.assessmentYear | convertNumWithOtherCharsToBn}}
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        ৬। আবাসিক মর্যাদা:
                    </div>
                    <div class="col-sm-2">
                        <div class="row">
                            <div class="col-sm-8">নিবাসী</div>
                            <div class="col-sm-4">
                                <input [checked]="userInfo?.residentStatus == 'Resident'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="row">
                            <div class="col-sm-8">অনিবাসী</div>
                            <div class="col-sm-4 text-right">
                                <input [checked]="userInfo?.residentStatus == 'Non Resident'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                    ৭। করদাতার বিশেষ সুবিধাপ্রাপ্তির ক্ষেত্রে টিক (&#10003;) চিহ্ন দিন
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-9">গেজেটভুক্ত যুদ্ধাহত মুক্তিযোদ্ধা</div>
                            <div class="col-sm-3">
                                <input [checked]="userInfo?.warWoundedFreedomFighter" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="row">
                            <div class="col-sm-6">নারী</div>
                            <div class="col-sm-6">
                                <input [checked]="userInfo?.gender == 'F'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-9">তৃতীয় লিঙ্গ</div>
                            <div class="col-sm-3">
                                <input [checked]="userInfo?.gender == 'O'" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-9">প্রতিবন্ধী ব্যক্তি</div>
                            <div class="col-sm-3 text-right">
                                <input [checked]="userInfo?.personWithDisability" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4 mr-5">
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-9">৬৫ বৎসর বা তদূর্ধ্ব বয়সের করদাতা</div>
                            <div class="col-sm-3">
                                <input [checked]="userInfo?.age" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="row">
                            <div class="col-sm-10">প্রতিবন্ধী ব্যক্তির পিতামাতা বা আইনানুগ অভিভাবক</div>
                            <div class="col-sm-2 text-right">
                                <input [checked]="userInfo?.guardianOfDisablePerson" class="input-checkbox" type="checkbox" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="mb-2">
                                    ৮। জন্ম তারিখ:
                                </div>
                                <div>
                                    দিন-মাস-বৎসর
                                </div>
                            </div>
                            <div class="col-sm-9 m-auto">
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobMonthChars" class="input-default" value="{{item | convertNumWithOtherCharsToBn}}" disabled/>
                                </span>
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobDayChars" class="input-default" value="{{item | convertNumWithOtherCharsToBn}}" disabled/>
                                </span>
                                <span class="mr-3">
                                    <input style="text-align: center;" *ngFor="let item of dobYearChars" class="input-default" value="{{item | convertNumWithOtherCharsToBn}}" disabled/>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row mb-2">
                            <div class="col-sm-12">
                                ৯। স্ত্রী বা স্বামীর নাম:
                                {{userInfo?.spouseName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 ml-3">
                                স্ত্রী/স্বামী করদাতা হলে হইলে টি আইএন: {{userInfo?.spouseTin | convertNumWithOtherCharsToBn}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col-sm-12">
                        ১০। যোগাযোগের ঠিকানা: {{userInfo?.presentAddress}}
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col-sm-12">টেলিফোন:</div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-6">মোবাইল: {{userInfo?.phone | convertNumWithOtherCharsToBn}}</div>
                    <div class="col-sm-6">ই-মেইল: {{userInfo?.email}}</div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        ১১। চাকরিজীবী করদাতার ক্ষেত্রে নিয়োগকারী প্রতিষ্ঠানের নাম (একাধিক প্রতিষ্ঠান হইলে সর্বশেষ প্রতিষ্ঠানের নাম):
                        {{lastEmployer}}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        ১২। (ক) ব্যবসা প্রতিষ্ঠানের নাম:
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12 ml-4">
                        (খ) ব্যবসায় নিবন্ধন নম্বর (BIN)(সমূহ): {{userInfo?.businessIdNumber}}
                    </div>
                </div>
                <div class="row my-4">
                    <div class="col-sm-12">
                        ১৩। ফার্ম বা ব্যক্তি সংঘের ক্ষেত্রে অংশীদার/সদস্যদের নাম ও টি আইএন (প্রয়োজনে পৃথক কাগজ ব্যবহার করুন):
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-sm-12"></div>
                </div>
           </div>
        </div>
    </div>
</div>
